var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillitLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 531.4 323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #dc6a02;\n      }\n\n      .cls-2 {\n        fill: #004c71;\n      }\n\n      .cls-3 {\n        fill: #ce470a;\n      }\n\n      .cls-4 {\n        fill: #00699d;\n      }\n\n      .cls-5 {\n        fill: #ef7d00;\n      }\n\n      .cls-6 {\n        display: none;\n      }\n\n      .cls-7 {\n        fill: #f18a00;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bill"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.2,313.2c6.5,2.6,16,4.8,28.1,6.4,12.2,1.6,24.5,2.5,36.8,2.6,10.2,0,19.3-1.2,26.9-3.5,7.5-2.3,13.5-5.4,17.9-9,4.5-3.8,8.1-8.5,10.7-13.8,2.7-5.5,4.6-11.4,5.6-17.4,1-6.8,1.5-13.7,1.5-20.6,0-22.6-3.5-38.8-10.3-48.4-6.6-9.1-18-13.7-34.1-13.7s-26.9,2.4-39.4,14.7l-9.3,9,3.8-12.4c2.6-8.6,2.4-14.5,2.1-25.2v-34.2H23.3v165.4h0ZM83.7,296.7c-5.9,0-11.7-.6-17.5-1.7l-2.7-.5v-62.1l1.8-1c8.3-4.5,15.9-6.8,22.5-6.8s14.7,2.5,17.7,7.6c2.8,4.6,4.2,13,4.2,25.8s-1.5,23.8-4.4,29.1c-3.2,5.8-9,9-17.4,9.3-1.4.2-2.7.2-4.1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.7,319.2h38.9v-119.4h-38.9v119.4ZM175.4,142.3c-7.1,0-10.1,3.1-10.1,10.3v13c0,5.6,4.5,10.1,10.1,10.1h20.1c6.9,0,9.9-3,9.9-10v-13.1c0-7.2-2.9-10.3-9.9-10.3h-20.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225.6,147.6v142.7c0,10.1,3.1,17.7,9.4,23.3,6.4,5.6,15.4,8.5,26.8,8.5s23.6-1.5,30.1-4.4l-4.4-25.3h-6.2c-14.5,0-16.7-9-16.7-14.3v-130.5h-39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.8,147.6v142.7c0,10.1,3.1,17.7,9.4,23.3,6.4,5.6,15.4,8.5,26.8,8.5s23.6-1.5,30.1-4.4l-4.4-25.3h-6.2c-14.5,0-16.7-9-16.7-14.3v-130.5h-39Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "it"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M383.3,319.2h38.9v-119.4h-38.9v119.4ZM392.1,142.3c-7.1,0-10.2,3.1-10.2,10.3v13c0,5.6,4.5,10.1,10.1,10.1h20.2c6.9,0,9.9-3,9.9-10v-13.1c0-7.2-2.9-10.3-9.9-10.3h-20.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M436.9,221.4h21.5v68.2c0,10.5,3,18.3,9.2,23.9s15.1,8.6,26.4,8.6,27.3-1.6,36.5-4.7l-4.2-25h-12.2c-5.4,0-9.1-1.1-11.7-3.3-2.5-2.2-3.8-5.9-3.8-11v-56.8h32.2v-22.8h-32.2v-33.6h-40.2v34.1l-21.5,1v21.4h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bird"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "230.3 69.9 212.4 47.3 204.1 69.8 204.2 69.8 230.3 69.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "212.4 47.3 174.4 47.3 204.1 69.8 212.4 47.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "193.4 93.9 204.1 69.8 174.4 47.3 117.4 88.6 193.4 93.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "113.7 137.6 193.4 93.9 125 .1 119.8 90.9 113.7 137.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "119.8 90.9 74 195.4 113.7 137.6 119.8 90.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.3,53v7.6h-5.9l53.3,58.9L125.1.1H37.5l30.6,33.7v-3.4h7.6v7.6h-3.8l19,20.9v-5.7h7.5v-.2ZM83.2,15.3h7.6v7.6h-7.6v-7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96.5,53L125,.1,51.5,15.5l16.4,18.2v-3.3h7.6v7.6h-3.7l18.8,20.7v-5.6h5.9ZM83.2,15.3h7.6v7.6h-7.6v-7.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 90.7,
    y: 68.2,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 105.9,
    y: 68.2,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 83.2,
    y: 60.6,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 105.9,
    y: 83.3,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "75.6 53 83.2 53 83.2 45.5 83.2 38 75.6 38 68 38 68 45.5 68 53 75.6 53"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68,
    y: 60.6,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "68 22.9 60.4 22.9 60.4 15.3 52.9 15.3 52.9 22.9 52.9 30.4 60.4 30.4 60.4 38 68 38 68 30.4 68 22.9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 60.4,
    y: 53,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 52.9,
    y: 38,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 45.3,
    y: 30.4,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 45.3,
    y: 45.5,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 45.3,
    y: 60.6,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 37.8,
    y: 15.3,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 37.8,
    y: 53,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 30.3,
    y: 22.9,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 30.3,
    y: 75.8,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.7,
    y: 38,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90.7,
    y: 7.7,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90.7,
    y: 38,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.7 60.6 90.7 68.2 98.3 68.2 98.3 75.8 105.9 75.8 105.9 68.2 105.9 60.6 98.3 60.6 90.7 60.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.7 45.5 83.2 45.5 83.2 53 83.2 60.6 90.7 60.6 90.7 53 90.7 45.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "83.2 75.8 83.2 83.3 90.7 83.3 90.7 90.9 98.3 90.9 98.3 83.3 105.9 83.3 105.9 75.8 98.3 75.8 90.7 75.8 83.2 75.8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 75.6,
    y: 30.4,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.4,83.3v7.6h7.6v-7.6s-7.6,0-7.6,0ZM113.4,75.8h-7.5v7.5h7.5v-7.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98.3,
    y: 90.9,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68,
    y: 15.3,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68,
    y: 53,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68,
    y: 83.3,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.4,
    y: 38,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.9,
    y: 30.4,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "52.9 53 52.9 60.6 60.4 60.6 60.4 53 60.4 45.5 52.9 45.5 52.9 53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "52.9 15.3 52.9 7.7 45.3 7.7 45.3 .2 37.8 .2 30.3 .2 22.7 .2 22.7 7.7 15.1 7.7 15.1 15.3 15.1 22.9 22.7 22.9 22.7 15.3 30.3 15.3 30.3 7.7 37.8 7.7 37.8 15.3 45.3 15.3 45.3 22.9 52.9 22.9 52.9 15.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "37.8 30.4 37.8 38 37.8 45.5 45.3 45.5 45.3 38 45.3 30.4 45.3 22.9 37.8 22.9 37.8 30.4"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 30.3,
    y: 15.3,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "75.6 60.6 75.6 68.2 75.6 75.8 83.2 75.8 83.2 68.2 83.2 60.6 75.6 60.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 60.4,
    y: 60.6,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 52.9,
    y: 75.8,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 45.3,
    y: 68.2,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 45.3,
    y: 83.3,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 37.8,
    y: 45.5,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "37.8 60.6 30.3 60.6 30.3 68.2 37.8 68.2 45.3 68.2 45.3 60.6 37.8 60.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 30.3,
    y: 30.4,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 22.7,
    y: 22.9,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "30.3 45.5 22.7 45.5 15.1 45.5 15.1 53 22.7 53 30.3 53 30.3 45.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 7.5,
    y: 0.2,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 7.5,
    y: 30.4,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 7.5,
    y: 60.6,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 0,
    y: 7.7,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 0,
    y: 22.9,
    width: 7.6,
    height: 7.6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Logo-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bill-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.2,313.2c6.5,2.6,16,4.8,28.1,6.4,12.2,1.6,24.5,2.5,36.8,2.6,10.2,0,19.3-1.2,26.9-3.5,7.5-2.3,13.5-5.4,17.9-9,4.5-3.8,8.1-8.5,10.7-13.8,2.7-5.5,4.6-11.4,5.6-17.4,1-6.8,1.5-13.7,1.5-20.6,0-22.6-3.5-38.8-10.3-48.4-6.6-9.1-18-13.7-34.1-13.7s-26.9,2.4-39.4,14.7l-9.3,9,3.8-12.4c2.6-8.6,2.4-14.5,2.1-25.2v-34.2H23.3v165.4h0ZM83.7,296.7c-5.9,0-11.7-.6-17.5-1.7l-2.7-.5v-62.1l1.8-1c8.3-4.5,15.9-6.8,22.5-6.8s14.7,2.5,17.7,7.6c2.8,4.6,4.2,13,4.2,25.8s-1.5,23.8-4.4,29.1c-3.2,5.8-9,9-17.4,9.3-1.4.2-2.7.2-4.1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.7,319.2h38.9v-119.4h-38.9v119.4ZM175.4,142.3c-7.1,0-10.1,3.1-10.1,10.3v13c0,5.6,4.5,10.1,10.1,10.1h20.1c6.9,0,9.9-3,9.9-10v-13.1c0-7.2-2.9-10.3-9.9-10.3h-20.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225.6,147.6v142.7c0,10.1,3.1,17.7,9.4,23.3,6.4,5.6,15.4,8.5,26.8,8.5s23.6-1.5,30.1-4.4l-4.4-25.3h-6.2c-14.5,0-16.7-9-16.7-14.3v-130.5h-39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.8,147.6v142.7c0,10.1,3.1,17.7,9.4,23.3,6.4,5.6,15.4,8.5,26.8,8.5s23.6-1.5,30.1-4.4l-4.4-25.3h-6.2c-14.5,0-16.7-9-16.7-14.3v-130.5h-39Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "it-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M383.3,319.2h38.9v-119.4h-38.9v119.4ZM392.1,142.3c-7.1,0-10.2,3.1-10.2,10.3v13c0,5.6,4.5,10.1,10.1,10.1h20.2c6.9,0,9.9-3,9.9-10v-13.1c0-7.2-2.9-10.3-9.9-10.3h-20.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M436.9,221.4h21.5v68.2c0,10.5,3,18.3,9.2,23.9s15.1,8.6,26.4,8.6,27.3-1.6,36.5-4.7l-4.2-25h-12.2c-5.4,0-9.1-1.1-11.7-3.3-2.5-2.2-3.8-5.9-3.8-11v-56.8h32.2v-22.8h-32.2v-33.6h-40.2v34.1l-21.5,1v21.4h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bird-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "230.3 69.9 212.4 47.3 204.1 69.8 204.2 69.8 230.3 69.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "212.4 47.3 174.4 47.3 204.1 69.8 212.4 47.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "193.4 93.9 204.1 69.8 174.4 47.3 117.4 88.6 193.4 93.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "113.7 137.6 193.4 93.9 125 .1 119.8 90.9 113.7 137.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "119.8 90.9 74 195.4 113.7 137.6 119.8 90.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.3,53v7.6h-5.9l53.3,58.9L125.1.1H37.5l30.6,33.7v-3.4h7.6v7.6h-3.8l19,20.9v-5.7h7.5v-.2ZM83.2,15.3h7.6v7.6h-7.6v-7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96.5,53L125,.1,51.5,15.5l16.4,18.2v-3.3h7.6v7.6h-3.7l18.8,20.7v-5.6h5.9ZM83.2,15.3h7.6v7.6h-7.6v-7.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 90.7,
    y: 68.2,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 105.9,
    y: 68.2,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 83.2,
    y: 60.6,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 105.9,
    y: 83.3,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "75.6 53 83.2 53 83.2 45.5 83.2 38 75.6 38 68 38 68 45.5 68 53 75.6 53"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68,
    y: 60.6,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "68 22.9 60.4 22.9 60.4 15.3 52.9 15.3 52.9 22.9 52.9 30.4 60.4 30.4 60.4 38 68 38 68 30.4 68 22.9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 60.4,
    y: 53,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 52.9,
    y: 38,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 45.3,
    y: 30.4,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 45.3,
    y: 45.5,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 45.3,
    y: 60.6,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 37.8,
    y: 15.3,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 37.8,
    y: 53,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 30.3,
    y: 22.9,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 30.3,
    y: 75.8,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.7,
    y: 38,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90.7,
    y: 7.7,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90.7,
    y: 38,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.7 60.6 90.7 68.2 98.3 68.2 98.3 75.8 105.9 75.8 105.9 68.2 105.9 60.6 98.3 60.6 90.7 60.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.7 45.5 83.2 45.5 83.2 53 83.2 60.6 90.7 60.6 90.7 53 90.7 45.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "83.2 75.8 83.2 83.3 90.7 83.3 90.7 90.9 98.3 90.9 98.3 83.3 105.9 83.3 105.9 75.8 98.3 75.8 90.7 75.8 83.2 75.8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 75.6,
    y: 30.4,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.4,83.3v7.6h7.6v-7.6s-7.6,0-7.6,0ZM113.4,75.8h-7.5v7.5h7.5v-7.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98.3,
    y: 90.9,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68,
    y: 15.3,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68,
    y: 53,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68,
    y: 83.3,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.4,
    y: 38,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.9,
    y: 30.4,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "52.9 53 52.9 60.6 60.4 60.6 60.4 53 60.4 45.5 52.9 45.5 52.9 53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "52.9 15.3 52.9 7.7 45.3 7.7 45.3 .2 37.8 .2 30.3 .2 22.7 .2 22.7 7.7 15.1 7.7 15.1 15.3 15.1 22.9 22.7 22.9 22.7 15.3 30.3 15.3 30.3 7.7 37.8 7.7 37.8 15.3 45.3 15.3 45.3 22.9 52.9 22.9 52.9 15.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "37.8 30.4 37.8 38 37.8 45.5 45.3 45.5 45.3 38 45.3 30.4 45.3 22.9 37.8 22.9 37.8 30.4"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 30.3,
    y: 15.3,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "75.6 60.6 75.6 68.2 75.6 75.8 83.2 75.8 83.2 68.2 83.2 60.6 75.6 60.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 60.4,
    y: 60.6,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 52.9,
    y: 75.8,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 45.3,
    y: 68.2,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 45.3,
    y: 83.3,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 37.8,
    y: 45.5,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "37.8 60.6 30.3 60.6 30.3 68.2 37.8 68.2 45.3 68.2 45.3 60.6 37.8 60.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 30.3,
    y: 30.4,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 22.7,
    y: 22.9,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "30.3 45.5 22.7 45.5 15.1 45.5 15.1 53 22.7 53 30.3 53 30.3 45.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 7.5,
    y: 0.2,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 7.5,
    y: 30.4,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 7.5,
    y: 60.6,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 0,
    y: 7.7,
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 0,
    y: 22.9,
    width: 7.6,
    height: 7.6
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillitLogo);
export default __webpack_public_path__ + "static/media/BillitLogo.39dfc23490ceb68b55a719ad736ea762.svg";
export { ForwardRef as ReactComponent };